import { IonToolbar, IonButtons, IonBackButton, isPlatform, IonTitle } from "@ionic/react";

export const Toolbar = () => {
  return (
    <IonToolbar>
      <IonButtons slot="start">
        <IonBackButton
          text={isPlatform("ios") ? "Plantillas" : ""}
          defaultHref="/app/tic/plantillas"
          color="light"
        />
      </IonButtons>
      <IonTitle>Nueva plantilla</IonTitle>
    </IonToolbar>
  );
};
